var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-block"},[_c('div',{staticClass:"left"},[_c('share-block')],1),_c('div',{staticClass:"right"},[_c('a',{attrs:{"href":"https://www.afisha.ru/","target":"_blank"},on:{"click":function($event){_vm.$ga.event('Ссылка', 'Афиша', 1)}}},[_c('span',{staticClass:"afisha"})])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5388a436","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBlock.vue
// module id = null
// module chunks = 